import React, { useState, useRef } from 'react';
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Card from 'bf-library/Card';
import Title from 'bf-library/Title';
import Input from 'bf-library/Input';
import Button from 'bf-library/Button';
import debounce from 'lodash/debounce';
import { API } from 'Services';

function CouponMandatoryForm(props) {
    const { intl, couponVoucherTerm, applyCoupon, channelId } = props;

    const [ isCouponValid, setIsCouponValid ] = useState(false);
    const [ couponCode, setCouponCode ] = useState('');
    const [ hasError, setHasError ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState('');
    const [ isProcessing, setIsProcessing ] = useState(false);

    const setCoupon = () => {
        applyCoupon(couponCode);
    };

    const handleError = (resp) => {
        setIsCouponValid(false);
        setHasError(true);
        if (resp.warnings[0].message) {
            setErrorMessage(resp.warnings[0].message);
        }
    };
    const debounceText = useRef(debounce((value) => {
        if (value.length) {
            setIsProcessing(true);
            API.validateCoupon({ couponCode: value, channelId })
                .then((resp) => {
                    setIsProcessing(false);
                    if (resp.result.valid) {
                        setIsCouponValid(true);
                        setHasError(false);
                    } else {
                        handleError(resp);
                    }
                })
                .catch((err) => {
                    handleError(err);
                });
        }
    }, 700));

    return (
        <div className="kbe-coupon-mandatory-form-main-wrapper">
            <Card className="kbe-coupon-mandatory-form-wrapper" largePadding>
                <Title
                    content={(
                        <FormattedMessage
                            id="bf.couponTerminologyFormTitle"
                            defaultMessage="bf.couponTerminologyFormTitle"
                            values={{ couponVoucherTerm }}
                        />
                    )}
                    size="large"
                    className="kbe-coupon-mandatory-form-title"
                />
                <Input
                    placeholder={intl.formatMessage({
                        id: 'bf.couponTerminologyCode',
                        defaultMessage: 'bf.couponTerminologyCode',
                    }, { couponVoucherTerm })}
                    className="kbe-coupon-mandatory-form-input"
                    onChange={(e) => {
                        debounceText.current(e.target.value); setCouponCode(e.target.value);
                    }}
                />
                { isCouponValid
                    ? (
                        <div className="kbe-coupon-form-feedback-message kbe-coupon-form-feedback-message-success">
                            <FormattedHTMLMessage
                                id="bf.couponTerminologyCodeIsValid"
                                defaultMessage="bf.couponTerminologyCodeIsValid"
                                values={{ couponVoucherTerm }}
                            />
                        </div>
                    )
                    : null}
                { hasError
                    ? (
                        <div className="kbe-coupon-form-feedback-message kbe-coupon-form-feedback-message-error">
                            {errorMessage}
                        </div>
                    )
                    : null}
                <Button
                    fluid
                    content={<FormattedMessage
                        id="bf.applyCouponTerminology"
                        defaultMessage="bf.applyCouponTerminology"
                        values={{ couponVoucherTerm }}
                    />}
                    primary
                    size="large"
                    className="kbe-coupon-mandatory-form-button"
                    disabled={!isCouponValid}
                    loading={isProcessing}
                    onClick={setCoupon}
                />
            </Card>
        </div>
    );
}

CouponMandatoryForm.defaultProps = {};

CouponMandatoryForm.propTypes = {
    intl              : intlShape.isRequired,
    couponVoucherTerm : PropTypes.string.isRequired,
    applyCoupon       : PropTypes.func.isRequired,
    channelId         : PropTypes.string.isRequired,
};

export default injectIntl(CouponMandatoryForm);
